import styles from "./PaymentStatus.module.scss";
import { Triangle } from "react-loader-spinner";
import Logo from "../../styles/pics/logo.png";
import { useHistory } from "react-router";
import successIcon from "../../styles/icon/successPay.svg";
import failedIcon from "../../styles/icon/failPay.svg";
import successPic from "../../styles/pics/paysuccess.svg";
import failedPic from "../../styles/pics/payfail.svg";

////P - FAILURE
export const PaymentFailed = () => {
  return (
    <section className={styles.status_container}>
      <div className={`${styles.status_title} ${styles.text_failed}`}>
        پرداخت ناموفق
      </div>
      <div className={`${styles.status_notification} ${styles.bg_failed}`}>
        <p>پرداخت شما ناموفق بود! دوباره تلاش کنید</p>
        <div className={styles.image}>
          <img src={failedIcon} alt="" width={18} />
        </div>
      </div>
      <main className={`${styles.status_details} ${styles.border_failed} `}>
        <div className={styles.failed_text_edit}>
          در صورت کسر وجه از حساب بانکی شما, تا ۷۲ ساعت آینده مبلغ از سمت بانک
          به حساب شما برگشت داده خواهد شد
        </div>
      </main>
      <div className={styles.status_icon}>
        <img src={failedPic} alt="FAILED" width={250} height={250} />
      </div>
    </section>
  );
};
////P - ACCEPTED
export const PaymentSuccess = () => {
  return (
    <section className={styles.status_container}>
      <div className={`${styles.status_title} ${styles.text_success}`}>
        تایید پرداخت
      </div>
      <div className={`${styles.status_notification} ${styles.bg_success}`}>
        <p>پرداخت شما با موفقیت انجام شد</p>
        <div className={styles.image}>
          <img src={successIcon} alt="" />
        </div>
      </div>
      <main className={`${styles.status_details} ${styles.border_success}`}>
        <div className={styles.grid_item}>
          <div>وضعیت تراکنش:</div>
          <div>
            <div>موفق</div>
          </div>
        </div>
        <div className={styles.grid_item}>
          <div>کد رهگیری:</div>
          <div>
            <div>235663324</div>
          </div>
        </div>
        <div className={styles.grid_item}>
          <div>شماره کارت:</div>
          <div>
            <div>63934610****4771</div>
          </div>
        </div>
        <div className={styles.grid_item}>
          <div>مبلغ:</div>
          <div>
            <div>1,000,000 تومان</div>
          </div>
        </div>
      </main>
      <div className={styles.status_icon}>
        <img src={successPic} alt="SUCCESS" width={250} height={250} />
      </div>
    </section>
  );
};
export default function PaymentStatus() {
  const history = useHistory();
  return (
    <div className={styles.container}>
      {/* Bottom component rendered when data released and send props to their components
        else Render ""Loading""
      */}
      <main>
        <PaymentSuccess />
        <div className={styles.container_btn}>
          {/* if status payment failure, btn styles => status_btn_failed, if success => status_btn_success */}
          <button
            className={`${styles.status_btn} ${styles.status_btn_success}`}
            onClick={() => history.replace("/my-wallet")}
          >
            بازگشت به کیف پول&zwnj;ها
          </button>
        </div>
      </main>
      {/*
       * 
       If this Page hasn't no data the Loading Page rendered -> 
       * 
       */}
      {/* <section className={styles.loading}>
        <section>
          <img src={Logo} alt="ARZFI" width={120} height={90} />
        </section>
        <div>
          <Triangle color="#10D078" height={80} width={80} />
        </div>
      </section> */}
    </div>
  );
}
